import './Petfinder.css'

function Petfinder() {
    
    return (
        <> 
        <pet-scroller
            s3Url="https://dbw3zep4prcju.cloudfront.net/"
            apiBase="https://psl.petfinder.com/graphql"
            organization='["NJ1046"]'
            status="adoptable"
            petfinderUrl="https://www.petfinder.com/"
            hideBreed="false"
            limit={24}
            petListTitle="">
        </pet-scroller>

        </>
    );
}

export default Petfinder;
